var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"lang-btn",on:{"click":_vm.toggleLanguage}},[_vm._v("\n  "+_vm._s(_vm.isChinese ? "En" : "中")+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }